import * as $ from 'jquery';
import 'slick-carousel';

const testimonialCarousel = () => {
	$(document).on('ready', function(){
		$('.testimonialCarousel__list').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 20000,
			arrows: false,
			dots: true,
			pauseOnHover: false,
			adaptiveHeight: false,
			// responsive: [
			// 	{breakpoint: 900, settings: {slidesToShow: 2}},
			// 	{breakpoint: 600, settings: {slidesToShow: 1}}
			// ]
		});
  	});
};

export default testimonialCarousel;